export const CommonMixin = {
    data: () => ({
        serverURL: '',
        sizes: {
            XS: 'X-Small',
            S: 'Small',
            M: 'Medium',
            L: 'Large',
            XL: 'X-Large',
            XXL: 'XX-Large',
        }
    }),
    computed: {
        isMobile() {
            return window.innerWidth <= 750
        }
    },
    mounted() {
        this.serverURL = process.env.VUE_APP_SERVER_URL.replace(/\\/g, '/');
    },
    methods: {
        async getUser() {
            const cookies = this.getCookie()
            if (!cookies?.authToken) {
                this.$notify('Для просмотра аккаунта необходимо авторизоваться')
                this.$router.replace({ path: '/auth/login' })
            }

            await this.$store.dispatch(`user/fetchActualUser`);

            this.user = JSON.parse(JSON.stringify(this.$store.state.user.actualUser))
            if (!this.user[0] || !this.user[0].ID) {
                this.$store.state.user.actualUser = []
                this.$notify('Для просмотра аккаунта необходимо авторизоваться')
                this.$router.replace({ path: '/auth/login' })
            }
        },
        setImageURL(obj) {
            if (obj) {
                try {
                    return this.serverURL + '/' + obj['Ссылка'].replace(/\\/g, '/')
                } catch (e) {
                    return '/'
                }
            } else {
                return '/'
            }
        },
        setImageThumbURL(obj) {
            if (obj) {
                try {
                    let link = obj['Ссылка'];
                    // link = link.replace(/\.jpeg$/i, '.webp');
                    // link = link.replace(/\.png$/i, '.webp');
                    link = this.serverURL + '/' + link.replace(/\\/g, '/');
                    link = link.replace(/\/uploads\//g, "/uploads/thumbnails/");

                    return link
                } catch (e) {
                    return '/'
                }
            } else {
                return '/'
            }
        },
        rgbToHex(r, g, b) {
            return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('')
        },
        getCaseByNumeral(num, word) {
            if (num > 20) {
                let array = num.toString().split('');
                switch (array[array.length - 1].toLowerCase()) {
                    case "1": return word;
                    case "2": return word + 'а';
                    case "3": return word + 'а';
                    case "4": return word + 'а';
                    default: return word + 'ов';
                }
            } else {
                switch (num) {
                    case 1: return word;
                    case 2: return word + 'а';
                    case 3: return word + 'а';
                    case 4: return word + 'а';
                    default: return word + 'ов';
                }
            }
        },
        handleInternalClick(event) {
            // использовать с директивой stop
            event.preventDefault(); // дополнительно предотвращает любые стандартные действия браузера
        },
        convertStringToDate(str) {
            const parts = str.split('.');
            return new Date(parts[2], parts[1] - 1, parts[0]); // Год, месяц (нумерация начинается с нуля), день
        },

        getCookie() {
            return document.cookie.split('; ').reduce((acc, item) => {
                const [name, value] = item.split('=')
                acc[name] = value
                return acc
            }, {})
        }
    }
}
